<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{ (category.id ? 'bikeshop.rentals.category.edit_category' : 'bikeshop.rentals.category.add_category') | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">


    <div class="row margin-top-8">
        <div class="col-md-4 label"
             [ngClass]="{ 'red' : !category.categoryName}">{{ 'bikeshop.rentals.category.category_name' | translate }}:
        </div>
        <div class="col-md-8">
            <input type="text" pInputText [(ngModel)]="category.categoryName"/>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">{{ 'bikeshop.rentals.category.force_selection' | translate }}:</div>
        <div class="col-md-8">
            <p-inputSwitch [(ngModel)]="category.forceSelection"></p-inputSwitch>
        </div>
    </div>

    <!-- <div class="row margin-top-8" *ngIf="category.forceSelection">
      <div class="col-md-4 label">{{ 'bikeshop.rentals.category.allow_bring_your_own' | translate }}:</div>
      <div class="col-md-8">
        <p-inputSwitch [(ngModel)]="category.allowBringYourOwn"></p-inputSwitch>
      </div>
    </div> -->


</div>
<div class="modal-footer">
    <div class="row margin-top-8">
        <div class="col-md-6">
            <button pButton type="button" class="p-button-raised alternate full-width" *ngIf="category.id"
                    label="{{'bikeshop.rentals.category.remove_category' | translate}}"
                    (click)="removeCategory()" [disabled]="busy"></button>
        </div>
        <div class="col-md-6">
            <button pButton type="button" class="p-button-raised full-width"
                    label="{{'bikeshop.rentals.category.save_category' | translate}}"
                    (click)="saveCategory()" [disabled]="busy || !valid()"></button>
        </div>
    </div>
</div>
<p-confirmDialog></p-confirmDialog>
